import { useState, useEffect } from 'preact/hooks';
import Card from './shared/Card.jsx';
import { formatEuros } from '../lib/format.js';

const REFRESH_MS = 15_000;

// MRR uit onze eigen abonnementen: maandbedragen tellen voor zichzelf,
// jaarbedragen gedeeld door twaalf.
export default function MrrTile({ refreshKey }) {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const res = await fetch('/api/subscriptions/mrr', { credentials: 'same-origin' });
        if (cancelled) return;
        if (!res.ok) { setFailed(true); return; }
        setData(await res.json());
        setFailed(false);
      } catch {
        if (!cancelled) setFailed(true);
      }
    }
    load();
    const i = setInterval(load, REFRESH_MS);
    return () => { cancelled = true; clearInterval(i); };
  }, [refreshKey]);

  return (
    <Card>
      <div class="mrr-tile">
        <div class="mrr-label muted">MRR — maandelijks terugkerende omzet</div>
        {failed ? (
          <div class="mrr-empty muted">Niet beschikbaar</div>
        ) : !data ? (
          <div class="mrr-empty muted">Laden…</div>
        ) : (
          <>
            <div class="mrr-amount">{formatEuros(data.mrrCents)}</div>
            <div class="mrr-meta muted">
              {data.activeCount} lopend {data.activeCount === 1 ? 'abonnement' : 'abonnementen'} · excl. BTW
            </div>
          </>
        )}
      </div>
    </Card>
  );
}
